import { useLocation } from "react-router-dom";
import ProductLists from "../features/products/ProductLists";
import useQueryTable from "../hooks/useQueryTable";
import QueryReTable from "../components/QueryReTable";
import { useUserServices } from "../context/DealerProfile";

const ProductListPage = ({ setFormData, isReturn }) => {
  const location = useLocation();
  const {
    dealerDetail: { dealerDiscountPercentage },
    priceItem,
  } = useUserServices();
  // console.log({ priceItem });
  const inPurchaseOrder = location.pathname.startsWith("/purchase-order");

  const [isLoading, data, searchValues, setSearchValues, moreData, totalData] =
    useQueryTable({
      queryList: ["page", "Product_Code", "Product_Name", "Description"],
    });

  const {
    data: { data: products },
  } = data ?? { data: { data: [] } };

  // products?.forEach((product) => {
  //   console.log("Book_id",product.Book_Id);
  //   product["Distributors_Discount_Price"] = (
  //     product?.["Unit_Price"] -
  //     (product?.["Unit_Price"] * dealerDiscountPercentage) / 100
  //   ).toFixed(2);
  // });

  // priceItem?.map((item) => {
  //   console.log(item?.item_id);
  // });

  // console.log({ products });

  // products?.forEach((product) => {
  //   priceItem.forEach((priceItem) => {
  //     if (priceItem.item_id === product.Book_Id) {
  //       console.log("Book_id", product.Book_Id);
  //       console.log("item metch.....",priceItem?.item_id);
  //       product["Distributors_Discount_Price"] = priceItem.pricebook_rate;
  //     } else {
  //       product["Distributors_Discount_Price"] = (
  //         product?.["Unit_Price"] -
  //         (product?.["Unit_Price"] * dealerDiscountPercentage) / 100
  //       ).toFixed(2);
  //     }
  //   });
  // });

  products?.forEach((product) => {
    // Initialize the discount price to the calculated value
    let calculatedDiscountPrice = (
      product?.["Unit_Price"] -
      (product?.["Unit_Price"] * dealerDiscountPercentage) / 100
    ).toFixed(2);

    // Check if there is a matching priceItem
    const matchingPriceItem = priceItem?.find(
      (item) => item.item_id === product.Book_Id
    );

    if (matchingPriceItem) {
      // console.log("Book_id", product.Book_Id);
      // console.log("Item match...", matchingPriceItem?.item_id);
      product["Distributors_Discount_Price"] = matchingPriceItem.pricebook_rate;
    } else {
      product["Distributors_Discount_Price"] = calculatedDiscountPrice;
    }
  });

  return (
    <QueryReTable
      buttonNeed={true}
      heading={"Product Lists"}
      headingNeed={!inPurchaseOrder}
      moreData={moreData}
      totalData={totalData}
      searchValues={searchValues}
      setSearchValues={setSearchValues}
    >
      <ProductLists
        setFormData={setFormData}
        isLoading={isLoading}
        products={products}
        searchValues={searchValues}
        setSearchValues={setSearchValues}
        isReturn={isReturn}
      />
    </QueryReTable>
  );
};

export default ProductListPage;
